import { ChevronLeft, ChevronRight } from 'lucide-react'

interface PaginationProps {
  page: number
  onPageChange: (page: number) => void
  count: number
  hasNext: boolean
  hasPrev: boolean
}

/** Pairs with DRF's default PageNumberPagination response shape:
 * { count, next, previous, results }. DRF doesn't return the configured
 * page size in the body, so this shows "N records" + Prev/Next rather than
 * "Page X of Y" — that avoids ever showing a wrong page count if
 * DEFAULT_PAGE_SIZE in the backend .env changes later.
 */
export default function Pagination({ page, onPageChange, count, hasNext, hasPrev }: PaginationProps) {
  if (!hasNext && !hasPrev) return null

  return (
    <div className="mt-6 flex items-center justify-between flex-wrap gap-3">
      <p className="text-sm text-neutral-500">
        Page {page} · {count} record{count === 1 ? '' : 's'} total
      </p>
      <div className="flex gap-2">
        <button
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={!hasPrev}
          className="flex items-center gap-1 px-3 py-1.5 border border-neutral-300 rounded-lg text-sm font-medium text-neutral-700 hover:bg-neutral-50 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <ChevronLeft className="w-4 h-4" /> Prev
        </button>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={!hasNext}
          className="flex items-center gap-1 px-3 py-1.5 border border-neutral-300 rounded-lg text-sm font-medium text-neutral-700 hover:bg-neutral-50 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Next <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
